import { MODULE_KEY } from '@/constants/modules';
import { useAuth } from '@/hooks/useAuth';
import { CalendarSyncSection } from './CalendarSyncSection';
import { NotificationProvidersSection } from '@/components/notifications/NotificationProvidersSection';
import { AssistantTargetRegion } from '@/components/assistant/uiActions/AssistantTargetRegion';
import { ASSISTANT_TARGET_KEY } from '@/components/assistant/uiActions/assistantTargetKeys';

export function IntegrationsSection() {
  const { enabledModules, activeWorkspace, isElevatedWorkspaceAccess } = useAuth();
  const isOwner =
    (activeWorkspace !== null && activeWorkspace.isOwner === true) || isElevatedWorkspaceAccess;
  const showCalendarSync = enabledModules.includes(MODULE_KEY.calendarSync);
  const showNotificationProviders =
    isOwner === true && enabledModules.includes(MODULE_KEY.communications);

  return (
    <div className="flex flex-col gap-6">
      {showCalendarSync === true ? (
        <AssistantTargetRegion targetKey={ASSISTANT_TARGET_KEY.integrationsCalendarSync}>
          <CalendarSyncSection />
        </AssistantTargetRegion>
      ) : null}
      {showNotificationProviders === true ? <NotificationProvidersSection /> : null}
    </div>
  );
}
